import { createAsyncActionTypes } from '../utils';

export const INVITE_PILOT = createAsyncActionTypes("INVITE_PILOT");
export const INVITE_PILOTS_LIST = createAsyncActionTypes("INVITE_PILOTS_LIST");
export const ASSIGNED_AIRCRAFT_LIST = createAsyncActionTypes("ASSIGNED_AIRCRAFT_LIST");
export const SELECTED_AIRCRAFT_LIST = createAsyncActionTypes("SELECTED_AIRCRAFT_LIST");
export const ASSIGN_AIRCRAFT_TO_PILOT = createAsyncActionTypes("ASSIGN_AIRCRAFT_TO_PILOT");
export const REMOVE_PILOT_BY_ID = createAsyncActionTypes("REMOVE_PILOT_BY_ID");
export const REMOVE_PROGRESS = 'REMOVE_PROGRESS';